import { render, staticRenderFns } from "./BindDevice.vue?vue&type=template&id=28c8316d&scoped=true&"
import script from "./BindDevice.vue?vue&type=script&lang=js&"
export * from "./BindDevice.vue?vue&type=script&lang=js&"
import style0 from "./BindDevice.vue?vue&type=style&index=0&id=28c8316d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8316d",
  null
  
)

export default component.exports